import React from 'react'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken,
    })
  }

  componentDidMount() {
    setDocumentTitle('How to delete your user information')
  }

  render() {
    return (
      <div className="policy">
        <h1>How to delete your user information</h1>
        <br />
        If you need to delete your user information, please log in to the app and submit feedback
        via: <b>Me > Feedback</b>.<br />
        Alternatively, you can delete your account directly by going to:{' '}
        <b>Me > Settings > Delete Account</b>.<br />
        If you're unable to log in to the app, please contact us at:{' '}
        <span className="contact">service@yayya.live</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/deleteapp/index.js